module.exports = __webpack_public_path__ + "static/img/officialPic.f7b3c98.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/officialPic.jpg
// module id = CvS+
// module chunks = 101